export function deleteBack(backElement) {
  let lastValue
  const onInput = (event)=>lastValue = event.target.value;
  const onKey = (event)=>{
    if(event.key == "Backspace" && !lastValue) {
      requestAnimationFrame(()=>backElement.focus())
    }
  }
  return (element) => {
    lastValue = element.value
    element.addEventListener("keydown", onKey)
    element.addEventListener("input", onInput)
    return ()=>{
      element.removeEventListener("keydown", onKey)
      element.removeEventListener("input", onInput)
    }
  }
}

export function inputForward(forwardElement, shouldForward = null) {
  const onInput = (event)=>{
    const element = event.target;
    if(event.data && (
      (element.maxLength && element.value.length === element.maxLength)
      || (shouldForward && shouldForward(element.value))
    )) {
      requestAnimationFrame(()=>forwardElement.focus())
    }
  }
  return (element) => {
    element.addEventListener("input", onInput)
    return ()=>element.removeEventListener("input", onInput)
  }
}
